export default {
    page_title: "Análise RFM",
    legend_frequency_monetary: "Média entre frequência e monetariedade",
    recency: "Recência",
    last_purchase: "Última compra",
    range_to: "a",
    purchases: "compras",
    made_in_last: "Feitas nos últimos",
    spent_in_last: "Gasto nos últimos",
    days: "dias",
    client: "Cliente",
    phone: "Telefone",
    email: "E-mail",
    frequency: "Frequência",
    monetary: "Monetário",
    score: "RFM Score",
};
